import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPreview from './pages/LandingPreview';
import PreLanding from './pages/PreLanding';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PreLanding />} />
          <Route path="/landing" element={<LandingPreview />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;